module.exports = __webpack_public_path__ + "Icon_Crashlab@2x.png?d311bd0a310b5ff4151bbea7931475fc";